import splide, { customSplide } from "../utils/splide";

const works = document.getElementById("works");
if (works) {
    const worksSplide = customSplide(works, {
        type: "slide",
        rewind: true,
        perPage: 3,
        autoplay: true,
        speed: 2000,
        gap: "25px",
        lazyLoad: "sequential",
        pagination: false,
        arrows: true,
        breakpoints: {
            1200: {
                perPage: 3,
                pagination: false,
                arrows: true,
                fixedHeight: "unset",
            },
            900: {
                perPage: 2,
                pagination: false,
                arrows: true,
                fixedHeight: "unset",
            },
            600: {
                perPage: 1,
                pagination: true,
                arrows: false,
                fixedHeight: false,
            },
        },
    });
    worksSplide.mount();
}

const banner = document.getElementById("banner");
if (banner) {
    customSplide(banner, {
        type: "fade",
        rewind: true,
        perPage: 1,
        autoplay: true,
        fixedHeight: "560px",
        speed: 2000,
        lazyLoad: "sequential",
        pagination: false,
        arrows: banner.dataset.slides > 1 ? true : false,
        breakpoints: {
            1200: {
                pagination: false,
                arrows: false,
                fixedHeight: "unset",
            },
            600: {
                fixedHeight: "unset",
                arrows: false,
                pagination: false,
            },
        },
    }).mount();
}

const faqArrow = document.querySelectorAll(".faqs__card__question");
faqArrow.forEach((arrow) => {
    arrow.addEventListener("click", () => {
        const upDownArrow = arrow
            .querySelector("i")
            .classList.contains("fa-caret-down")
            ? "fa-caret-up"
            : "fa-caret-down";
        arrow.querySelector("i").classList.toggle(upDownArrow);
    });
});
